export const MOKKANO_BRAND_IDS = [293_480];

export const ADMIN_ROLE_IDS = [2, 6];

function getHostName() {
    return typeof location !== 'undefined' ? location.hostname : '';
}

export const BIG_BRAND_IDS = getHostName().includes('.space')
    ? [4674, 65_682, 65_768]
    : [
          110_758, 110_763, 110_757, 110_762, 110_756, 110_498, 110_753, 110_489, 12_467, 205_051, 287_803, 312_602,
          191_810, 376_267, 57_346, 260_346, 122_460, 219_146, 106_345,
      ];

export const mokkanoReviewStatuses = [
    {
        statusCode: 'not_processed',
        availableStatus: ['in_process', 'abuse_sent', 'review_deleted'],
    },
    {
        statusCode: 'processed',
        availableStatus: ['in_process', 'decided', 'request_info'],
    },
    {
        statusCode: 'in_process',
        availableStatus: ['not_processed', 'processed', 'request_info'],
    },
    {
        statusCode: 'decided',
        availableStatus: ['processed', 'request_info', 'abuse_sent'],
    },
    {
        statusCode: 'request_info',
        availableStatus: ['in_process', 'decided'],
    },
    {
        statusCode: 'abuse_sent',
        availableStatus: ['not_processed', 'in_process', 'decided', 'review_deleted'],
    },
    {
        statusCode: 'review_deleted',
        availableStatus: ['not_processed', 'abuse_sent'],
    },
    {
        statusCode: 'review_changed',
        availableStatus: ['in_process', 'abuse_sent', 'review_deleted'],
    },
];

export const WGIS_SUPPORT_USER_ID = [1_342_522];
